export enum TypeOfCRUD {
  CREATE = 'ADD',
  UPDATE = 'EDIT',
  DELETE = 'DELETE',
}
